import { Trash2 } from 'lucide-react';
import type * as React from 'react';
import { ConfirmDialog } from '@verclam/ui-kit';

type Props = {
	readonly visible: boolean;
	/** « {list name} {n} », as the document shows it. */
	readonly itemName: string;
	readonly isDocumentVerified: boolean;
	readonly onAccept: () => void;
	readonly onHide: () => void;
};

/**
 * Removal of one list element. A plain `ConfirmDialog` with no retyped name: the removal is a loop
 * gesture the user repeats, an exception to the hard-deletion rule limited to list elements. On a
 * verified document the reopening notice lives in this same message, so one removal never asks twice.
 */
const RemoveListItemDialog: React.FC<Props> = ({
	visible,
	itemName,
	isDocumentVerified,
	onAccept,
	onHide,
}) => {
	const message = isDocumentVerified
		? 'Ses champs seront retirés du document. Ce geste repassera le document en cours de vérification.'
		: 'Ses champs seront retirés du document.';

	return (
		<ConfirmDialog
			visible={visible}
			onHide={onHide}
			header={`Supprimer « ${itemName} » ?`}
			icon={<Trash2 size={24} aria-hidden="true" />}
			message={message}
			acceptLabel="Supprimer"
			rejectLabel="Annuler"
			acceptSeverity="danger"
			accept={onAccept}
			reject={onHide}
		/>
	);
};

export default RemoveListItemDialog;
